import { Ref, ref } from '@vue/composition-api'

// models
import { IEmployee } from '@/models/config'

// services
import { EmployeeService } from '@/services/config'

export default function useEmployeesOp () {
  const employees: Ref<IEmployee[]> = ref([])
  const loadingEmployees = ref(false)

  const getEmployees = async () => {
    loadingEmployees.value = true
    employees.value = await EmployeeService.getActivated()
    loadingEmployees.value = false
  }

  return { employees, getEmployees, loadingEmployees }
}
